/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAxisY = createReactComponent("axis-y", "IconAxisY", [
  ["path", { d: "M11 20h-.01", key: "svg-0" }],
  ["path", { d: "M15 20h-.01", key: "svg-1" }],
  ["path", { d: "M19 20h-.01", key: "svg-2" }],
  ["path", { d: "M4 7l3 -3l3 3", key: "svg-3" }],
  ["path", { d: "M7 20v-16", key: "svg-4" }]
]);

export { IconAxisY as default };
//# sourceMappingURL=IconAxisY.js.map
